import { Link } from 'react-router-dom'
import { Typography } from '../Typography'
import { TableCellLinkProps } from './types'
import styles from './styles.module.scss'

export const TableCellLink = ({
  to,
  children,
  dataTestId,
}: TableCellLinkProps) => (
  <Link
    to={to}
    className={styles.link}
    onClick={(e) => e.stopPropagation()}
    data-testid={dataTestId}
  >
    <Typography name="Subtitle7" Tag="span">
      {children}
    </Typography>
  </Link>
)
